<template>
  <div class="container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="stylus">
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.mint-toast-text {
  color: #fff !important;
}

.mint-msgbox-message {
  text-align: left !important;
  line-height: 18px !important;
}

.mint-toast.c-toast {
  width: 6rem;

  span {
    line-height: 0.48rem;
  }
}

.m-picker {
  .m-picker-box {
    .m-picker-header {
      span {
        line-height: 0.8rem !important;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue